import React from "react";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import GenericModal from "../GenericComponents/GenericModal";
import "./CustomDeleteFontsModal.scss";

export default function CustomDeleteFontsModal({
  open,
  onYes,
  onNo,
  fontLabel,
  isDeleting = false,
}) {
  const handleNo = () => {
    if (isDeleting) return;
    onNo?.();
  };

  return (
    <GenericModal
      open={open}
      onClose={handleNo}
      disableBackdropClose
      disableEscapeKeyClose
      className="custom-delete-fonts-modal"
      width={400}
      height="auto"
      title="DELETE FONT"
      footer={
        <div className="custom-delete-fonts-footer">
          <Button
            onClick={handleNo}
            disabled={isDeleting}
            className="footer-plain-btn"
            style={{ border: "none" }}
          >
            NO
          </Button>
          <Button
            onClick={onYes}
            disabled={isDeleting}
            className="Footer-btns"
          >
            {isDeleting ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              "YES"
            )}
          </Button>
        </div>
      }
    >
      <p className="custom-delete-fonts-message">
        Are you sure you want to delete this font ?
      </p>
      
      {fontLabel ? (
        <p className="custom-delete-fonts-label">{fontLabel}</p>
      ) : null}
    </GenericModal>
  );
}
